import { backButton } from '@tma.js/sdk-react'
import { useEffect, useEffectEvent } from 'react'

type TelegramBackButtonProps = {
  isVisible: boolean
  onClick: () => void
}

export const TelegramBackButton = ({
  isVisible,
  onClick,
}: TelegramBackButtonProps) => {
  const handleClick = useEffectEvent(onClick)

  useEffect(() => {
    return () => {
      backButton.hide.ifAvailable()
    }
  }, [])

  useEffect(() => {
    if (isVisible) {
      backButton.show.ifAvailable()
    } else {
      backButton.hide.ifAvailable()
    }
  }, [isVisible])

  useEffect(() => {
    if (!isVisible) {
      return
    }

    const offBack = backButton.onClick.ifAvailable(() => {
      handleClick()
    })

    return () => {
      if (offBack.ok) {
        offBack.data()
      }
    }
  }, [isVisible])

  return null
}
